export default "__VITE_ASSET__a85d573f__"